/*
 * 첫 화면 데이터 미리 담기: 서버가 index.html에 그 화면이 처음 부를 API 응답을 넣어 보내고(window.__PRELOAD__),
 * 앱의 첫 요청은 네트워크 대신 그것을 쓴다. 원격 접속에서 왕복 몇 번을 줄인다.
 */

/** 요청 하나를 가리키는 열쇠 (서버·앱이 같게 만든다). GET은 주소, 그 밖은 "방법 주소 본문" */
export function preloadKey(method: string, url: string, body?: unknown): string {
  return method === "GET" ? url : `${method} ${url} ${JSON.stringify(body ?? {})}`;
}

/** 미리 담은 응답을 쓸 수 있는 시간 (페이지를 연 뒤). 그 뒤의 요청은 늘 네트워크로 */
export const PRELOAD_TTL_MS = 15_000;
